// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__vtq5J","mainContent":"DashboardLayout_mainContent__EGTSM","content":"DashboardLayout_content__cvMPx"};